import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const sfCityOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'san-francisco',
  neighborhoodSlug: 'san-francisco',
  neighborhoodDisplayName: 'San Francisco',
  metroDisplayName: 'San Francisco',
  totalCodiClientsInNeighborhood: 45,
  whereFromStreetsToLandmark:
    'from offices across SoMa, the Financial District, Mission Bay, Potrero Hill, and Hayes Valley to the buildings near Caltrain Station and the Ferry Building',
  whereTeamStreets: 'Brannan St, Market St, California St, 3rd St, Howard St, 2nd St',
  clientDescriptor: 'a software startup near the Financial District',
  counts: {
    managedCleaningOffices: 35,
    managedPantryOffices: 45,
    managedInternetOffices: 40,
    managedFurnitureOffices: 25,
    managedOfficeAssistantOffices: 25,
    managedDeepCleaningOffices: 20,
    managedCarpetCleaningOffices: 15,
    managedWindowCleaningOffices: 12,
    managedGlassCleaningOffices: 22,
    managedWasteRecyclingOffices: 18,
    managedPantryInventoryOffices: 38,
    managedCoffeeServiceOffices: 30,
    managedWaterServiceOffices: 28,
    managedTeamLunchOffices: 18,
    managedBreakfastCateringOffices: 14,
    managedIndividualMealsOffices: 12,
    managedAdHocCateringOffices: 20,
    managedHappyHourOffices: 16,
    managedConferenceRoomAvOffices: 22,
    managedNetworkInstallationOffices: 36,
    managedNetworkManagementOffices: 28,
    managedCableManagementOffices: 18,
    managedRoomBookingOffices: 16,
    managedPrintingSetupOffices: 26,
    managedInteriorDesignOffices: 16,
    managedOfficeMuralsOffices: 7,
    managedOfficePaintingOffices: 10,
    managedGlassFrostingOffices: 12,
    managedOfficeSignageOffices: 8,
    managedCareRoomOffices: 6,
    managedFurnitureAssemblyOffices: 20,
    managedLayoutChangeOffices: 13,
    managedOfficePlantsOffices: 18,
    managedKeylessAccessOffices: 20,
    managedAlarmSystemsOffices: 12,
    managedSecurityCamerasOffices: 18,
    managedKeypadOffices: 15,
    managedLockboxOffices: 8,
    managedVisitorManagementOffices: 14,
    managedBusinessInsuranceOffices: 16,
    managedElectricalServicesOffices: 22,
    managedHvacOffices: 18,
    managedPlumbingOffices: 15,
    managedPestControlOffices: 12,
    managedOfficeMovingOffices: 20,
    managedMountingInstallationOffices: 28
  },
  quotes: {
    cleaning: 'We needed cleaning, pantry, and someone to coordinate vendors. Codi handles all of it.',
    pantryRestocking: 'The pantry was always running out. Since Codi took it over, it just stays stocked.',
    internet:
      'Most SF office buildings have fiber in the risers. Codi deployed managed wifi and coordinated riser access \u2014 we just showed up.',
    officeAssistant:
      "Codi's on-site person handles all the little things \u2014 packages, vendors, tidying \u2014 so the team can focus.",
    officeFurniture:
      'We had a whole furniture order and no one to coordinate it. Codi handled everything including the freight dock.',
    deepCleaning: 'Quarterly deep cleans used to be a half-day coordination project. Codi just runs it.',
    carpetCleaning:
      'Professional carpet cleaning across SF offices, coordinated by Codi \u2014 zero effort from our team.',
    windowCleaning: 'SF high-rise windows need regular care. Codi manages the vendor and all building access.',
    glassConferenceRoom:
      'Glass conference walls across our SF offices are always spotless. Codi owns the maintenance schedule.',
    wasteRecycling:
      "SF's composting and recycling rules are strict. Codi manages compliant pickup for all our offices.",
    pantryInventory:
      'Pantry inventory tracking across SF offices used to require a dedicated coordinator. Codi automated all of it.',
    coffeeService:
      'Coffee service across our SF offices \u2014 Codi manages equipment, bean sourcing, and maintenance for every location.',
    waterService:
      'Filtered water dispensers across SF offices, all serviced on a set schedule by Codi. Zero maintenance overhead.',
    teamLunch:
      'Recurring team lunches across SF offices. Codi sources local caterers and handles all delivery logistics.',
    breakfastCatering:
      'Office breakfast programs across San Francisco. Codi manages vendors and delivery for every location.',
    individualMeals:
      'Daily individual meal delivery for SF offices. Codi manages vendors, coordination, and delivery logistics.',
    adHocCatering:
      'On-demand catering for SF offices \u2014 board meetings, all-hands, client lunches. Codi handles it every time.',
    happyHour:
      'Office happy hours across San Francisco. Codi manages drinks sourcing, delivery, and setup for every event.',
    conferenceRoomAv:
      'Conference room A/V across SF offices \u2014 Codi manages sourcing, installation, and ongoing maintenance for every location.',
    networkInstallation:
      'Network installations across SF offices. Codi handles ISP provisioning, structured cabling, and managed switch deployment.',
    networkManagement:
      'Managed network services across San Francisco offices. Codi monitors, maintains, and troubleshoots every office network.',
    cableManagement:
      'Cable management across SF offices \u2014 Codi organizes, labels, and documents cable infrastructure for every location.',
    roomBooking:
      'Room-booking systems deployed across SF offices. Codi installs tablets, configures software, and handles ongoing maintenance.',
    printingSetup:
      'Printer setup and management across San Francisco offices. Codi handles freight, installation, drivers, and ongoing support.',
    interiorDesign:
      'Interior design and space planning across SF offices. Codi manages concept through installation for offices in SoMa, the Financial District, and beyond.',
    officeMurals:
      'Office murals across San Francisco. Codi sources local artists, coordinates building approval, and manages installation for offices citywide.',
    officePainting:
      'Office painting across SF offices. Codi coordinates after-hours access, COI compliance, and painter scheduling for all locations.',
    glassFrosting:
      'Glass frosting installation across San Francisco offices. Codi manages measurement, material sourcing, and installation across all neighborhoods.',
    officeSignage:
      'Office signage across SF. Codi designs, fabricates, and installs lobby, wayfinding, and brand signage for offices across the city.',
    careRoom:
      'Care room setups across San Francisco offices. Codi furnishes and equips private care rooms for offices in every SF neighborhood.',
    furnitureAssembly:
      'Furniture assembly and repairs across SF offices. Codi coordinates freight elevator access and assembly crews for offices citywide.',
    layoutChange:
      'Office layout changes across San Francisco. Codi manages furniture reconfiguration, cable rerouting, and building coordination for offices across SF.',
    officePlants:
      'Office plant programs across San Francisco. Codi sources, places, and maintains plants for offices in SoMa, the Financial District, and all SF neighborhoods.',
    keylessAccess:
      'Keyless access management across SF offices. Codi handles installation, credential setup, and ongoing management for offices in SoMa, the Financial District, and beyond.',
    alarmSystems:
      'Alarm system installation across San Francisco offices. Codi coordinates vendor selection, building approval, and ongoing monitoring for offices citywide.',
    securityCameras:
      'Security camera installation across SF offices. Codi manages placement, network integration, and ongoing system management for offices throughout the city.',
    keypads:
      'Door keypad installation and management across San Francisco offices. Codi installs, configures, and manages access codes for offices in every SF neighborhood.',
    lockboxes:
      'Office lockbox management across San Francisco. Codi coordinates placement, building compliance, and access distribution for SF offices citywide.',
    visitorManagement:
      'Visitor management systems deployed across San Francisco offices. Codi handles hardware delivery, software setup, and compliance management for offices across the city.',
    businessInsurance:
      'Business insurance coordination across SF offices. Codi manages policy sourcing, certificate generation, and annual renewals for offices in SoMa, the Financial District, and all SF neighborhoods.',
    electricalServices:
      'Electrical services across San Francisco offices. Codi manages licensed C-10 contractors, DOB permits, and building coordination for electrical projects in SoMa, the Financial District, and all SF neighborhoods.',
    hvac: 'HVAC maintenance and repairs across SF offices. Codi manages licensed HVAC vendors and building engineering coordination for offices in SoMa, the Financial District, and all San Francisco neighborhoods.',
    plumbing:
      'Plumbing services across San Francisco offices. Codi coordinates licensed C-36 contractors, building notifications, and permit filing for plumbing projects in offices citywide.',
    pestControl:
      'Pest control programs across SF offices. Codi manages licensed PCO operators, quarterly treatment scheduling, and compliance documentation for offices in every San Francisco neighborhood.',
    officeMoving:
      'Office moving coordination across San Francisco. Codi manages mover selection, freight elevator booking, COI documentation, and full setup for office moves in SoMa, the Financial District, and beyond.',
    mountingInstallation:
      'Mounting and installation services across SF offices. Codi coordinates vetted installation vendors and manages TV, whiteboard, and signage mounting for offices throughout San Francisco.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: 'all'
});
